<template>
    <div class="decision-tree-wrap">
        <div v-if="!('deleted' in model && model.deleted)" class="decision-tree" :class="{'has-node': isNode}">
            <div class="decision-tree-node-wrap">
                <div v-if="type !== 'root'" :class="{bold: isNode}" @click="show" @dblclick="changeType" class="decision-tree-node">
                    {{ node.decision_node_translation_set[0].title }}
                    <!--<span v-if="isNode">[{{ open ? '-' : '+' }}]</span>-->
                </div>
                <div v-if="isNode" class="decision-tree-items">
                    <decision-tree-edit
                            class="item"
                            v-for="(child, index) in node.children"
                            :key="index"
                            :domains="domains"
                            :model="child"
                            :parent_article="parent_article"
                            :product="product">
                    </decision-tree-edit>
                    <div class="decision-tree-add">
                        <button class="btn btn-light" @click="addChild">+</button>
                    </div>
                </div>
            </div>
        </div>
        <node-form
                v-if="showForm"
                :node="node"
                :formType="formType"
                :domains="domains"
                :product="product"
                @toggleForm="toggleForm"
                @saveCurrentNode="saveForm">
        </node-form>
    </div>
</template>
<script>
    import NodeForm from './NodeForm.vue';
    export default {

        props: ['type', 'domains', 'model', 'parent_article', 'product'],
        components: {
            'node-form': NodeForm,
        },
        data: function () {
            if (this.type === "root" && window.localStorage.getItem('decision_tree' + this.parent_article)) {
                return {
                    node: JSON.parse(window.localStorage.getItem('decision_tree'+ this.parent_article)),
                    showForm: false,
                    formType: 'edit',
                }
            }
            return {
                node: this.model,
                showForm: false,
                formType: 'edit',
            }
        },
        computed: {
            isNode: function () {
                return this.node.type === 'node';
            }
        },

        methods: {

            getNode: function() {
              return this.node;
            },

            toggleForm: function(toggle) {
                this.showForm = toggle;
            },

            show: function () {
                this.formType = 'edit';
                this.showForm = true;
            },

            getRefs: function(node) {
                return Object.keys(node.$refs).length ? node.$refs : this.getRefs(node.$parent);
            },

            saveForm(nodeForm) {
                if (nodeForm.isNewNode) {
                    this.node.children.push({
                        parent_article: this.parent_article,
                        article: nodeForm.article,
                        article_details: nodeForm.article_details,
                        type: nodeForm.type,
                        order: nodeForm.order,
                        children: [],
                        decision_node_translation_set: [
                            {
                                language: locale,
                                title: nodeForm.title,
                            }
                        ],
                        deleted: false,
                    })
                } else {
                    if (this.node.article !== nodeForm.article) {
                        this.node.article_details = nodeForm.article_details;
                    }
                    this.node.article = nodeForm.article;
                    this.node.decision_node_translation_set[0].title = nodeForm.title;
                    this.node.order = nodeForm.order;
                    this.node.type = nodeForm.type;
                    this.node['deleted'] = nodeForm.deleted;
                }
                this.showForm = false;
                var ref = this.getRefs(this);
                window.localStorage.setItem('decision_tree' + this.parent_article, JSON.stringify(ref.tree.getNode()));
            },

            changeType: function () {
                if (!this.isNode) {
                    Vue.set(this.node, 'type', 'node');
                    this.addChild();
                    this.open = true
                }
            },
            addChild: function () {
                this.formType = 'new';
                this.showForm = true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/decision-tree/Edit.vue